import { createContext } from 'react';

// When provided, consuming components call this instead of navigating away.
// Used by BridgePlaylist to close the overlay on back/finish.
const PlaylistExitContext = createContext<(() => void) | null>(null);

export default PlaylistExitContext;
